/* eslint-disable import/first */
// Suppress known third-party library warnings - must be at very top before any imports
const suppressedWarnings = [
  'findDOMNode',
  'onPageChange',
  'onChangePage',
  'onChangeRowsPerPage',
  'onRowsPerPageChange',
  'defaultProps will be removed',
  'Failed prop type',
  'aria-hidden',
  'unique "key" prop',
  'is deprecated',
  'deprecated. Use',
  'TablePagination',
  'React Router Future Flag',
  'Function components cannot be given refs'
];

const shouldSuppress = (args: any[]) => {
  const message = args.map(arg => String(arg)).join(' ');
  return suppressedWarnings.some(warning => message.includes(warning));
};

const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

console.error = function(...args: any[]) {
  if (shouldSuppress(args)) return;
  originalConsoleError.apply(console, args);
};

console.warn = function(...args: any[]) {
  if (shouldSuppress(args)) return;
  originalConsoleWarn.apply(console, args);
};

// Also suppress in window.console for React DevTools
if (typeof window !== 'undefined') {
  const origError = window.console.error;
  const origWarn = window.console.warn;
  
  window.console.error = function(...args: any[]) {
    if (shouldSuppress(args)) return;
    origError.apply(window.console, args);
  };
  
  window.console.warn = function(...args: any[]) {
    if (shouldSuppress(args)) return;
    origWarn.apply(window.console, args);
  };
}

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from './serviceWorker';
import { startVersionDetector } from './versionDetector';
import { setEnvironment, setAppVersion } from './Config/Environment';
import { getAppConfiguration } from './Config';
import Package from '../package.json';
import LogRocket from 'logrocket';
import { CssBaseline } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core";
import theme from "./Theme/theme";
import moment from 'moment';
import 'moment/locale/sv';
import 'moment/locale/en-gb';
import './Prototypes/Array';
/* eslint-enable import/first */

var locale = (window.navigator as any).userLanguage || window.navigator.language;
moment.locale(locale);

startVersionDetector();
setEnvironment().then(() => {
  setAppVersion(Package.version);
  init();
});

const init = () => {
  const logrocketKey = getAppConfiguration().logrocketKey;
  if (logrocketKey) {
    LogRocket.init(logrocketKey, {
      network: {
        requestSanitizer: (request) => {
          if (request.url.toLowerCase().indexOf('meta') !== -1) {
            return null;
          }

          return request;
        },
      },
    });
  }
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
   <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline>
          <App/>
        </CssBaseline>
      </ThemeProvider>
   </React.StrictMode>
);
serviceWorker.unregister();
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
